import { useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PanelFrame from "../ui/PanelFrame";
import siteConfig from "../../config/siteConfig";
import featuredArt from "../../assets/imgs/ui/features/featured-armor.png";
import btnCta from "../../assets/imgs/ui/buttons/panel-cta-sm.png";
import onlineJewel from "../../assets/imgs/ui/status/online-jewel.png";
import event01 from "../../assets/imgs/ui/events/event-01.png";
import event02 from "../../assets/imgs/ui/events/event-02.png";
import event03 from "../../assets/imgs/ui/events/event-03.png";
import event04 from "../../assets/imgs/ui/events/event-04.png";
import event05 from "../../assets/imgs/ui/events/event-05.png";
import gallery01 from "../../assets/imgs/ui/gallery/gallery-01.png";
import gallery02 from "../../assets/imgs/ui/gallery/gallery-02.png";
import gallery03 from "../../assets/imgs/ui/gallery/gallery-03.png";
import gallery04 from "../../assets/imgs/ui/gallery/gallery-04.png";
import gallery05 from "../../assets/imgs/ui/gallery/gallery-05.png";
import gallery06 from "../../assets/imgs/ui/gallery/gallery-06.png";
import gallery07 from "../../assets/imgs/ui/gallery/gallery-07.png";
import gallery08 from "../../assets/imgs/ui/gallery/gallery-08.png";
import gallery09 from "../../assets/imgs/ui/gallery/gallery-09.png";
import gallery10 from "../../assets/imgs/ui/gallery/gallery-10.png";
import badgeNew from "../../assets/imgs/ui/decorations/badge-new.png";
import cornerBracket from "../../assets/imgs/ui/decorations/corner-bracket.png";
import { useLiveEventCountdowns } from "../../utils/eventCountdown";
import "./homePanels.scss";

const EVENT_ICONS = [event01, event02, event03, event04, event05];
const GALLERY_IMGS = [
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  gallery10,
];

const formatNumber = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return Number(value).toLocaleString("en-US");
};

const PanelCta = ({ to, href, children }) => {
  const style = { backgroundImage: `url(${btnCta})` };
  if (to) {
    return (
      <Link className="mu-panel-cta-btn" style={style} to={to}>
        {children}
      </Link>
    );
  }
  return (
    <a className="mu-panel-cta-btn" style={style} href={href || "#"}>
      {children}
    </a>
  );
};

export const ServerStatus = () => {
  const online = useSelector(
    (s) => s.reducerWeb?.playersOnline?.data?.playersOnline,
  );
  const onlineText =
    online == null || online === "" ? "—" : formatNumber(online);

  return (
    <PanelFrame
      title="Server Status"
      headerRight={
        <span className="mu-status-online">
          <img src={onlineJewel} alt="" /> ONLINE
        </span>
      }
    >
      <ul className="mu-kv-list">
        <li>
          <span>Server Name</span>
          <strong>{siteConfig.serverName}</strong>
        </li>
        <li>
          <span>Version</span>
          <strong>{siteConfig.version}</strong>
        </li>
        <li>
          <span>Experience</span>
          <strong>{siteConfig.experience}</strong>
        </li>
        <li>
          <span>Drop Rate</span>
          <strong>{siteConfig.dropRate}</strong>
        </li>
        <li>
          <span>{siteConfig.playersOnlineLabel}</span>
          <strong className="mu-online-text">{onlineText}</strong>
        </li>
      </ul>
    </PanelFrame>
  );
};

export const UpcomingEventsPanel = () => {
  const events = useSelector((s) => s.reducerWeb?.eventTimes?.data) || [];
  const liveEvents = useLiveEventCountdowns(events);
  const fallback = siteConfig.upcomingEvents || [];
  const rows = liveEvents.length
    ? liveEvents.slice(0, 5)
    : fallback.map((ev) => ({ name: ev.name, time: "--:--:--" }));

  return (
    <PanelFrame title="Upcoming Events">
      <ul className="mu-events-list">
        {rows.map((ev, i) => (
          <li key={`${ev.name}-${i}`}>
            <img
              className="mu-events-list__icon"
              src={EVENT_ICONS[i % EVENT_ICONS.length]}
              alt=""
            />
            <span className="mu-events-list__name">{ev.name}</span>
            <span className="mu-events-list__timer" title="Countdown to start">
              {ev.time || "--:--:--"}
            </span>
          </li>
        ))}
      </ul>
      <div className="mu-panel-cta">
        <PanelCta to="/events">VIEW ALL EVENTS</PanelCta>
      </div>
    </PanelFrame>
  );
};

export const PlayerStatsPanel = () => {
  const stats = useSelector((s) => s.reducerWeb?.playerStats?.data);
  const rows = [
    { label: "Total Players", value: formatNumber(stats?.totalPlayers) },
    { label: "Total Resets", value: formatNumber(stats?.totalResets) },
    { label: "Kills Today", value: formatNumber(stats?.killsToday) },
    { label: "Total Zen", value: formatNumber(stats?.totalZen) },
  ];

  return (
    <PanelFrame title="Player Statistics">
      <ul className="mu-kv-list">
        {rows.map((row) => (
          <li key={row.label}>
            <span>{row.label}</span>
            <strong>{row.value}</strong>
          </li>
        ))}
      </ul>
    </PanelFrame>
  );
};

export const FeaturedItem = () => {
  const item = siteConfig.featuredItem;
  return (
    <PanelFrame title={item.subtitle}>
      <div className="mu-featured">
        <img src={featuredArt} alt="" />
        <h3>{item.title}</h3>
        <PanelCta to={item.link}>VIEW</PanelCta>
      </div>
    </PanelFrame>
  );
};

export const GalleryPanel = () => {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState(0);
  const [animKey, setAnimKey] = useState(0);
  const labels = siteConfig.gallery || [];
  const visible = [0, 1, 2, 3].map((o) => (index + o) % GALLERY_IMGS.length);

  const slide = (delta) => {
    setDir(delta);
    setAnimKey((k) => k + 1);
    setIndex((v) => (v + delta + GALLERY_IMGS.length) % GALLERY_IMGS.length);
  };

  return (
    <PanelFrame title="Community Gallery">
      <div className="mu-gallery">
        <button
          type="button"
          className="mu-gallery__arrow mu-gallery__arrow--prev"
          aria-label="Previous"
          onClick={() => slide(-1)}
        >
          <img src={cornerBracket} alt="" />
        </button>
        <div
          key={animKey}
          className={`mu-gallery__thumbs${
            dir < 0 ? " is-slide-right" : dir > 0 ? " is-slide-left" : ""
          }`}
        >
          {visible.map((imgIdx, i) => (
            <figure key={`${imgIdx}-${i}`}>
              <img src={GALLERY_IMGS[imgIdx]} alt="" />
              <figcaption>
                {labels[imgIdx % labels.length]?.label || `Shot ${imgIdx + 1}`}
              </figcaption>
            </figure>
          ))}
        </div>
        <button
          type="button"
          className="mu-gallery__arrow mu-gallery__arrow--next"
          aria-label="Next"
          onClick={() => slide(1)}
        >
          <img src={cornerBracket} alt="" />
        </button>
      </div>
      <div className="mu-panel-cta">
        <PanelCta href={siteConfig.social.discordInvite}>VIEW GALLERY</PanelCta>
      </div>
    </PanelFrame>
  );
};

export const NewsPanel = () => (
  <PanelFrame title="News & Announcements">
    <ul className="mu-news-list">
      {siteConfig.news.map((n) => (
        <li key={n.id || n.title}>
          <Link to={`/news#${n.id || ""}`}>
            <span className="mu-news-list__diamond" />
            <span className="mu-news-list__title">
              {n.title}
              {n.tag ? (
                <img
                  className="mu-news-list__badge"
                  src={badgeNew}
                  alt={n.tag}
                />
              ) : null}
            </span>
            <span className="mu-news-list__date">{n.date}</span>
          </Link>
        </li>
      ))}
    </ul>
    <div className="mu-panel-cta">
      <PanelCta to="/news">VIEW ALL NEWS</PanelCta>
    </div>
  </PanelFrame>
);
